module.exports = __webpack_public_path__ + "static/img/Rejuvenation-1.05f10c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/Rejuvenation-1.png
// module id = WXVZ
// module chunks = 1